import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { IconButton } from "../../../controls/TooltipControls";
import { midClip, truthy } from "../../../util/util";
import { setModType } from "../../mod_management/actions/mods";
import { activeGameId } from "../../profile_management/selectors";
import { getGame } from "../util/getGame";
import { getModType, getModTypeExtensions } from "../util/modTypeExtensions";
function ModTypeWidget(props) {
    const mods = Array.isArray(props.mods) ? props.mods : [props.mods];
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const modTypeId = mods[0].type;
    const gameMode = useSelector(activeGameId);
    const discovery = useSelector((state) => state.settings.gameMode.discovered[gameMode]);
    const modTypes = React.useMemo(() => getModTypeExtensions(), []);
    const modTypePath = React.useMemo(() => {
        let result = "";
        const game = getGame(gameMode);
        const modType = getModType(modTypeId);
        if (modType !== undefined && game !== undefined) {
            result = modType.getPath(game);
        }
        else if (game !== undefined) {
            result = game.getModPaths(discovery?.path)[""];
        }
        return result;
    }, [gameMode, modTypeId]);
    const choices = React.useMemo(() => {
        return modTypes
            .filter((type) => type.isSupported(gameMode))
            .map((type) => ({
            key: type.typeId,
            text: type.options.name || type.typeId || "Default",
        }));
    }, [gameMode]);
    const onChangeValue = React.useCallback((newValue) => {
        for (const mod of mods) {
            dispatch(setModType(gameMode, mod.id, newValue?.key || ""));
        }
    }, [gameMode]);
    const toClipboard = React.useCallback(() => {
        if (modTypeId) {
            props.copyToClipboard(modTypeId);
        }
    }, [modTypeId, props.copyToClipboard]);
    const openPath = React.useCallback(() => {
        window.api.shell.openFile(modTypePath);
    }, [modTypePath]);
    if (mods[0].state !== "installed") {
        return React.createElement("div", null, t("Only available for installed mods"));
    }
    if (mods.find((iter) => iter.type !== modTypeId) !== undefined) {
        return React.createElement("div", null, t("Multiple"));
    }
    return (React.createElement("div", null,
        React.createElement(Select, { labelKey: "text", options: choices, value: modTypeId, valueKey: "key", onChange: onChangeValue }),
        truthy(modTypePath) ? (React.createElement("div", null,
            t("Deploys to"),
            "\u00A0",
            React.createElement("a", { className: "modtype-path", title: modTypePath, onClick: openPath }, midClip(modTypePath, 40)))) : (t("Does not deploy")),
        React.createElement("div", null,
            t("ID:"),
            "\u00A0",
            React.createElement("span", { className: "modtype-id" },
                "\"",
                modTypeId,
                "\""),
            "\u00A0",
            React.createElement(IconButton, { className: "btn-embed", icon: "clipboard-copy", tooltip: t("Copy ID to clipboard"), onClick: toClipboard }))));
}
export default ModTypeWidget;
